/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気契約情報
 */
export interface Szma103aResElecCtrInfoDto {
    /**
     * 検針日選択区分：英数字
     */
    ksdateSentakuDiv?: string;
    /**
     * 検針日選択区分名称：全角
     */
    ksdateSentakudivAname?: string;
    /**
     * 関連会社区分：英数字
     */
    relatedcompanyDiv?: string;
    /**
     * 関連会社区分名称：全半角混在
     */
    relatedCompanyDivaname?: string;
    /**
     * 関連会社お客さま番号：数字
     */
    relatedcompanyVisitornumber?: string;
}

